// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Qy1zt","col":"CardReaderDesc_col__1bdd2","label":"CardReaderDesc_label__2XP_4"};